export const AuthErrorCodes = {
	systemError: 1,
	dealerNotFound: 2,
	inactiveDealer: 3
}